<section>
    <div class="block" [hidden]="patientParms.hidden || flagPatient==1 ">
        <div class="title-tab-step">
            {{ 'patientSearch' | translate }}
        </div>

        <div class="row m-0" [hidden]="patientParms.hidden">
            <div class="col p-0">
                <app-fast-search [appCodes]="[2000,1272]" [searchType]="patientParms" (toggle)="togglefillter()"
                    (searchKeys)="onSearchClick($event)" ngDefaultControl [appearFastSearch]="false">
                </app-fast-search>
            </div>
        </div>
    </div>

    <div class="row m-0 p-0 mt-2">
        <div class="col-sm-4" [hidden]="patientParms.hidden|| flagPatient==1" style="padding-top: 20px;">
            <div class="row" *ngIf="showaddNewBornNicuVaccinBtn">
                <div class="col-md-8">
                    <span class="colordnnew">
                        {{'motherName' | translate }} :
                    </span>
                    <span class="smalfont">
                        {{translate.currentLang == 'ar' ? newBornList[0].motherNameAr : newBornList[0].motherNameEn}}
                    </span>
                </div>
                <div class="col-md-4 align-right">
                    <i class="fa fa-1x fa-phone">{{newBornList[0].mobile}}</i>
                </div>
            </div>
            <div class="row" *ngIf="showaddNewBornNicuVaccinBtn">
                <div class="col-md-8">
                    <span class="colordnnew">
                        {{'fatherName' | translate }} :
                    </span>
                    <span class="smalfont">
                        {{translate.currentLang == 'ar' ? newBornList[0].fatherFullnameAr :
                        newBornList[0].fatherFullnameEn}}
                    </span>
                </div>
            </div>
            <div [ngClass]="{'mt-4': showaddNewBornNicuVaccinBtn}">
                <p-dataTable tableStyleClass="table table-bordered table-striped ui-state-highlight"
                    [value]="newBornList" selectionMode="single" [rows]="20" [pageLinks]="3"
                    [rowsPerPageOptions]="[5,10,20,50,100]" (onRowSelect)="onActionIconsClicked($event.data)"
                    [rowStyleClass]="getCssClasses">
                    <p-column header="{{ 'BABYPATCODE' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData">
                            <span>
                                {{row.babyPatCode}}
                            </span>
                        </ng-template>
                    </p-column>

                    <p-column header="{{ 'NEWBORNNAME' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData">
                            <div>
                                {{ translate.currentLang == 'ar' ? row.newBornNameAr: row.newBornNameEn }}
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '10%'}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <span>
                                <icon-action (clicked)="onNewBornRowClicked($event,row,null)"
                                    [appCodes]="getOrderActionIcon(row)"></icon-action>
                            </span>
                        </ng-template>
                    </p-column>
                </p-dataTable>
            </div>

        </div>

        <div [ngClass]="flagPatient==1 ? 'col-sm-12' : 'col-sm-8'" class="col-sm-8">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>{{ 'ADDNICUVACCIN' | translate }}</label>
                        <sanabel-selectize appcode="1273" #nicuVaccin [multi]="true" [simpleView]="true"
                            (addSelected)="addNicuVaccin($event)">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>
            <div>
                <p-dataTable class="table table-responsive"
                    tableStyleClass="table table-bordered table-hover table-striped" [value]="nicuVaccinTransList"
                    [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
                    [rowsPerPageOptions]="[5,10,20,50,100]">
                    <p-column header="{{ 'ADDNICUVACCIN' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData">
                            <div class="col-sm-12" *ngIf="row.updatestatus == 2">
                                <sanabel-selectize appcode="1273" [simpleView]="true" [(ngModel)]="row.vaccinSerial"
                                    name="vaccinSerial">
                                </sanabel-selectize>
                            </div>
                            <div *ngIf="row.updatestatus != 2">
                                {{ translate.currentLang == 'ar' ? row.vaccinNameAr: row.vaccinNameEn }}
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column header="{{ 'doctorName' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData">
                            <div class="col-sm-12" *ngIf="row.updatestatus == 2">
                                <sanabel-selectize appcode="1020" [simpleView]="true" [(ngModel)]="row.docId"
                                    name="docId">
                                </sanabel-selectize>
                            </div>
                            <div *ngIf="row.updatestatus != 2 ">
                                {{ translate.currentLang == 'ar' ? row.docNameAr: row.docNameEn }}
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column header="{{ 'NICUVACCINDATE' | translate }}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <div class="col-sm-12" *ngIf="row.updatestatus == 2">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                        [(ngModel)]="row.vaccinationDate" name="vaccinationDate" ngbDatepicker
                                        #dateF="ngbDatepicker">
                                    <div class="input-group-addon" (click)="dateF.toggle()">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="row.updatestatus !=2">
                                <i>
                                    {{row['vaccinationDate'] | date:'dd/MM/yyyy'}}
                                </i>
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column header="{{ 'INOUTPATIENTFLAG' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData">
                            <div class="col-sm-12" *ngIf="row.updatestatus == 2">
                                <sanabel-selectize appcode="373" [simpleView]="true" [(ngModel)]="row.inOutHospitalFalg"
                                    name="inOutHospitalFalg">
                                </sanabel-selectize>
                            </div>
                            <div *ngIf="row.updatestatus !=2">
                                {{ translate.currentLang == 'ar' ? row.inOutHospitalFalgNameAr:
                                row.inOutHospitalFalgNameEn }}
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column header="{{ 'NOTES' | translate }}" [sortable]="true">
                        <ng-template pTemplate="options" let-row="rowData" let-index="rowIndex">
                            <div *ngIf="row.updatestatus !=2">
                                {{row.notes}}
                            </div>
                            <div *ngIf="row.updatestatus ==2">
                                <textarea class="form-control" type="text" [(ngModel)]="row.notes" rows="1"></textarea>
                            </div>
                        </ng-template>
                    </p-column>
                    <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '10%'}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <span *ngIf="row.updatestatus != 2" class="">
                                <icon-action *ngIf="row.compositeFlag != 1" (clicked)="onRowClicked($event,row,null)"
                                    [appCodes]="getOrderActionIcon(row)"></icon-action>
                            </span>
                            <div>
                                <button *ngIf="row.updatestatus == 2" class="btn btn-info btn-sm"
                                    (click)="undoEdit(row);">
                                    <i class="fa fa-undo fa-1x"></i>
                                </button>
                                <button *ngIf="row.updatestatus == 2" class="btn btn-success btn-sm"
                                    (click)="deleteRow(row);">
                                    <i class="fa fa-trash fa-1x"></i>
                                </button>
                            </div>
                        </ng-template>
                    </p-column>
                </p-dataTable>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <btns-ctrl #btnCtrl [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>